export const FEATURE_FLAGS_ACTIONS = {
    SET_FLAGS: 'SET_FEATURE_FLAGS',
    SET_FLAG: 'SET_FEATURE_FLAG',
    SET_STATUS: 'SET_FEATURE_FLAGS_STATUS',
    SET_CURRENT_STATUS: 'SET_FEATURE_FLAG_CURRENT_STATUS',
    SET_ERRORS: 'SET_FEATURE_FLAGS_ERRORS',
    CLEAR_ERRORS: 'CLEAR_FEATURE_FLAGS_ERRORS',
    CLEAR_FLAGS: 'CLEAR_FEATURE_FLAGS',
    CLEAR_CURRENT: 'CLEAR_FEATURE_FLAG_CURRENT'
};
export const initialFeatureFlagsState = {
    status: 'idle',
    errors: [],
    data: {},
    current: null,
    currentStatus: 'idle'
};
